import { render, staticRenderFns } from "./RMBids.vue?vue&type=template&id=995efca0"
import script from "./RMBids.vue?vue&type=script&lang=js"
export * from "./RMBids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports